var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogoBrex = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "currentColor",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.096 2.898c-.55.734-.677.977-1.205.977H1v9.38h3.094c.698 0 1.375-.334 1.81-.898.563-.748.642-.976 1.19-.976H15V2h-3.115c-.699 0-1.376.335-1.79.898m2.452 6.06h-3.3c-.72 0-1.376.299-1.811.883-.563.749-.677.977-1.205.977H3.431V6.32h3.3c.72 0 1.376-.335 1.81-.898.564-.735.72-.956 1.227-.956h2.773v4.491z"
})));
export default SvgLogoBrex;